import { useCallback } from 'react';
import modalsPageActions from 'store/modals/modalsPageActions';
import { useCheckCanAssignWorklog } from './useCheckCanAssignWorklog';
import useAddResources from './useAddResources';
import { updateSheets } from 'store/schedule/schedulePageOperation';
import { useDispatch, useSelector } from 'react-redux';
import { SCHEDULE_VIEW_TYPES } from 'pages/ScheduleV6/constants/constants';

export const useHandleDrop = ({
  sheet,
}) => {
  const dispatch = useDispatch();
  const { scheduleView, sheets } = useSelector(store => store.schedule);

  const openModal = useCallback((...args) => dispatch(modalsPageActions.openModal(...args)), [dispatch]);
  const { checkCanAssignWorklog } = useCheckCanAssignWorklog();
  const { addResource } = useAddResources();

  const handleDrop = async (e) => {
    if (sheet.canceledAt) return;

    const { canAssign, data } = await checkCanAssignWorklog({
      e,
      sheet,
      openModal,
      sheets,
    });

    if (!canAssign) return;

    const fullListResource = data.resourceType === 'workers' ? sheet.workers : sheet.equipment
    const resource = { _id: data.resource._id };

    await addResource({
      sheetId: sheet._id,
      resources: { [data.resourceType]: [resource,...fullListResource] },
    })
      .then((res) => {
        if (scheduleView === SCHEDULE_VIEW_TYPES.daily) dispatch(updateSheets());
        if (res.error !== 'sheet-time-overlapse') return;
        openModal({
          name: 'conflict',
          data: {
            to: sheet._id,
            from: res.details[0].overlappedSheets.find(
              (s) => s._id !== sheet._id
            ),
            addData: data,
            removeData: {
              resourceId: data.resource._id,
              resourceType: data.resourceType,
            },
          }
        });
      })
      .catch((err) => {
        openModal({ name: 'info', data: err?.response?.data?.message || err.message });
      });
  }

  return { handleDrop };
};
